export default {
  selectedCampaign: "",
  campaign: {},
};
